// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"438":"Login","494":"Register","723":"Manager"}[chunkId] + "." + {"438":"334d84dc","494":"46d3206c","723":"ae724903"}[chunkId] + ".js";
};